import { MINIMUM_LIST_WIDTH } from '../../../../../common/constants';

const MAX_WIDTH_RATIO = 0.9;

export const getMaxListWidth = (viewportWidth: number) => {
	const tableLimitedWidth = Math.round(viewportWidth * MAX_WIDTH_RATIO);

	return Math.max(MINIMUM_LIST_WIDTH(), tableLimitedWidth);
};
